/**
 * Age-band filter for the free catalogue (drip publication, 2026-09-22).
 * Three bands, derived the same way whether we start from a story's
 * `age_min` or a child's own age — pure functions so both Catalogue.tsx
 * (filter pills) and any future screen can share the exact same cutoffs.
 */
import type { StoryCard } from "./types";

export type AgeBand = "all" | "3-5" | "5-7" | "8-10";

/** Band a *child* belongs to, from their age — used to preset the filter
 *  pill when the catalogue loads. */
export function bandForAge(age: number): AgeBand {
  if (age <= 4) return "3-5";
  if (age <= 7) return "5-7";
  return "8-10";
}

/** Band a *story* belongs to, from its `age_min` — same cutoffs as
 *  `bandForAge` so a 6-year-old child and a story with `age_min: 6` land in
 *  the same band. */
export function bandOf(story: Pick<StoryCard, "age_min">): AgeBand {
  if (story.age_min <= 4) return "3-5";
  if (story.age_min <= 7) return "5-7";
  return "8-10";
}
